<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options"/>
  </div>
</template>
<script>
const TableName = 'VUETABLE_SNAPSHOT';
export default {
    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: [
                'code',
                'name',
                'total_quantity',
                'net_sales',
                'total_sales',
            ],
            options: {
                texts: {
                    title: 'Product Sales',
                    description: 'Shows product sale details',
                },
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                headings: {
                    code: 'Code',
                    name: 'Name',
                    total_quantity: 'Quantity',
                    net_sales: 'Net Sales',
                    total_sales: 'Total Sales',
                },
                pdf_url: Laroute.route(
                    'franchise.report.snapshot.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.snapshot.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.snapshot.exportAsFile',
                    { type: 'XLSX' },
                ),
                templates: {
                    net_sales: (h, row) => {
                        return numeral(parseFloat(row.net_sales)).format();
                    },
                    total_sales: (h, row) => {
                        return numeral(parseFloat(row.total_sales)).format();
                    },
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.snapshot.product');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/snapshot/vuetable_snapshot.vue